module.exports = __webpack_public_path__ + "static/media/waving-hand.adb33ad0.png";